"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendMessageBack;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendMessageBack() {
  return (0, _useWebChatAPIContext.default)().sendMessageBack;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VTZW5kTWVzc2FnZUJhY2siLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsInNlbmRNZXNzYWdlQmFjayJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVNlbmRNZXNzYWdlQmFjay50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVNlbmRNZXNzYWdlQmFjaygpOiAodmFsdWU6IGFueSwgdGV4dD86IHN0cmluZywgZGlzcGxheVRleHQ/OiBzdHJpbmcpID0+IHZvaWQge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5zZW5kTWVzc2FnZUJhY2s7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLGtCQUFULEdBQXlGO0VBQ3RHLE9BQU8sSUFBQUMsNkJBQUEsSUFBdUJDLGVBQTlCO0FBQ0QifQ==